export default __webpack_public_path__ + "static/media/radiant-bright-orange-pink.1d39d60f.jpg";